import React from "react";
import BankMaster from "./BankMaster";
import ChequeStatusMaster from "./ChequeStatusMaster";
import ChequeTypeMaster from "./ChequeTypeMaster";

export default function ChequeMastersSection({ onMastersChange }) {
  return (
    <div
      id="ci-masters"
      className="user-builder-panel"
      style={{ scrollMarginTop: "2rem" }}
    >
      <div className="user-builder-panel__head">
        <h3 className="user-builder-panel__title">Master table management</h3>
        <p className="user-builder-panel__hint">
          Configure banks, cheque statuses, and cheque types used when recording
          cheques. All lookup values are created here — nothing is pre-seeded.
        </p>
      </div>

      <div id="ci-banks" style={{ marginTop: "1.5rem", scrollMarginTop: "2rem" }}>
        <BankMaster onMastersChange={onMastersChange} />
      </div>

      <div id="ci-chq-status" style={{ marginTop: "2.5rem", scrollMarginTop: "2rem" }}>
        <ChequeStatusMaster onMastersChange={onMastersChange} />
      </div>

      <div id="ci-chq-types" style={{ marginTop: "2.5rem", scrollMarginTop: "2rem" }}>
        <ChequeTypeMaster onMastersChange={onMastersChange} />
      </div>
    </div>
  );
}
